import { apiClient } from "@/core/api/ApiClient";

/** Service for files BE API (not local files). */
export class FileService {
  public async tryDelete(params: { fileId: Nil<string> }): Promise<void> {
    if (params.fileId) {
      try {
        await apiClient.filesApi.apiV1FilesFileIdDelete({
          fileId: params.fileId,
        });
      } catch (err) {
        // ignore: file might be used already
        console.error(err);
      }
    }
  }
}

export const fileService = new FileService();
